import PropTypes from 'prop-types'
import { useEffect } from 'react'

import FormGroup from '../../../components/ReusableComponents/ManageHotel/FormGroup/index'
import TextInput from '../../../components/ReusableComponents/ManageHotel/TextInput/index'
import Toggle from '../../../components/ReusableComponents/Toggle/index'
import styles from './Services.module.scss'

const Services = ({
  disabled,
  platformAccessFee,
  setPlatformAccessFee,
  handleValidated,
  done,
  hostMessagingAuthorizingPartyFullName,
  setHostedMessagingData
}) => {
  useEffect(() => {
    if (platformAccessFee && platformAccessFee > 0) {
      handleValidated(true)
    } else {
      handleValidated(false)
    }
  }, [platformAccessFee, handleValidated])

  return (
    <FormGroup title="Services &amp; requests" disabled={disabled} done={!!done}>
      <div>
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            marginBottom: 10
          }}
        >
          <TextInput
            type="number"
            label="Platform access fee"
            value={platformAccessFee}
            onChange={e => setPlatformAccessFee(e.target.value)}
            className={styles.dollarInput}
          />
        </div>
      </div>
      <hr />
      <HostedMessaging
        HostMessagingAuthorizingPartyFullName={hostMessagingAuthorizingPartyFullName}
        setHostedMessagingData={setHostedMessagingData}
      />
    </FormGroup>
  )
}

const HostedMessaging = ({
  HostMessagingAuthorizingPartyFullName,
  setHostedMessagingData
}) => {
  return (
    <div className={styles.request}>
      <Toggle
        label="Hosted messaging"
        isGray
        checked={HostMessagingAuthorizingPartyFullName !== null}
        handleChange={e => setHostedMessagingData(e.target.checked ? '' : null)}
      />
      {HostMessagingAuthorizingPartyFullName !== null && (
        <TextInput
          className={styles.requestInput}
          placeholder="Full name of authorized party"
          width={400}
          value={HostMessagingAuthorizingPartyFullName}
          onChange={e => setHostedMessagingData(e.target.value)}
        />
      )}
    </div>
  )
}

Services.propTypes = {
  subscriptions: PropTypes.object.isRequired,
  setSubscriptions: PropTypes.func.isRequired
}

export default Services
